export default {
  hero: {
    title1: "网红每日大赛",
    title2: "实时追踪爆料",
    subtitle: "51爆料是你搜黑料、看大赛的集合站。聚合51爆料网、51爆料吃瓜及全网反差不设防的吃瓜视频，所有八卦和明星消息都在这里。",
    cta: "立即进入吃瓜频道",
  },
  hotTopics: {
    badge: "热门八卦",
    title: "全网黑料追踪",
    viewArticle: "查看文章",
  },
  categoryNav: {
    title1: "分类导航",
    title2: "找你想看的",
    highlight: "吃瓜",
    highlight2: "黑料",
  },
  testimonials: {
    title: "网友热评",
    subtitle: "看看大家都在讨论什么",
    viewPost: "查看原帖",
  },
};